/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromAggregate from 'Simple/Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaToggle from 'DesignSystem/TysiaToggle/index'
import TysiaToggleButton from 'DesignSystem/TysiaToggle/TysiaToggleButton/index'
import TysiaToggleText from 'DesignSystem/TysiaToggle/TysiaToggleText/index'
import viewPath from './viewPath.js'



/**
 * @type {(
 *  props: {
 *    [x: string]: any,
 *    children?: React.ReactNode,
 *    viewPath: typeof viewPath
 *  }) => React.JSX.Element}
 */
export default function Content({
  children,
  viewPath = "/DesignSystem/PaymentProvider/PaymentProviderCaptureMethod/Content/ReusuableToggle/Content",
  isSubmitting
  
}) {
let paymentReusableValueData = fromData.useDataValue({ viewPath,
context: 'payment',
path: 'reusable',
})
let paymentIsSubmittingData = fromData.useDataIsSubmitting({ viewPath,
context: 'payment',
})
let onChange = fromHelpers.useOnChange({
  children,
  viewPath,
  isSubmitting
  
})
let paymentMethodValueData = fromData.useDataValue({ viewPath,
context: 'payment',
path: 'method',
})
let constantData = 'ach'
let aggregateData = fromAggregate.equals(paymentMethodValueData, constantData)
  return (<React.Fragment
>
<TysiaToggle
  viewPath={`${viewPath}/TysiaToggle`}
 justifyContent="flex-start"
 marginTop={0}
 data="payment.reusable"
 value={paymentReusableValueData}
 onChange={onChange}
 data="payment"
 disabled={paymentIsSubmittingData}
>
{childProps => (
<React.Fragment>
<TysiaToggleButton
{...childProps}
  viewPath={`${viewPath}/TysiaToggleButton`}
/>
<TysiaToggleText
{...childProps}
  viewPath={`${viewPath}/TysiaToggleText`}
 text={aggregateData ? "Save this bank account" : "Save this card"}
 data="payment.method"
 data="'ach'"
 aggregate="/Simple/Data/aggregate.js equals"
/>
</React.Fragment>
)}
</TysiaToggle>
{children}
</React.Fragment>)
}